import { type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function Card({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('panel p-6', className)} {...props}>
      {children}
    </div>
  );
}

type SectionHeaderProps = {
  kicker?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
};

export function SectionHeader({ kicker, title, description, action, className }: SectionHeaderProps) {
  return (
    <header className={cn('flex items-end justify-between gap-6 mb-6', className)}>
      <div>
        {kicker && <div className="kicker mb-2">{kicker}</div>}
        <h2 className="font-display text-3xl text-text tracking-tight leading-none">
          {title}
        </h2>
        {description && (
          <p className="mt-2 text-sm text-text-muted max-w-xl leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </header>
  );
}
